/* eslint-disable complexity */
import { validationMixin } from 'vuelidate';
import { mapGetters } from 'vuex';
import {
	ACTION_GET_PRICE_DATA,
	ACTION_SAVE_FORM_DATA_BACKEND,
	CHECKOUT_STORE_NAMESPACE,
	MUTATION_SET_FORM_FIELDS_DATA,
	MUTATION_SET_VALIDATION_META,
} from '@/store/checkout';
import dynamicValidateData from '~/utils/dynamicValidate';

export default {
	mixins: [validationMixin],
	props: [
		'formData',
		'personNumber',
		'currentStep',
		'product',
		'event',
		'sellablePrograms',
	],
	computed: {
		...mapGetters({
			getAdditionalPersonsCount: 'checkout/getAdditionalPersonsCount',
			getIsRegistrant: 'checkout/getIsRegistrant',
			getScenario: 'checkout/getScenario',
			getSignerPersonNumber: 'checkout/getSignerPersonNumber',
		}),
	},
	data() {
		return {
			form: {},
			isValid: null,
			isValidSelf: null,	// валидность первой персоны
			notFirstAttempt: null,
			isValidExclusion: null,
			baseApiUrl: process.env.BASE_API_URL,
		};
	},
	created() {
		this.form = this.$store.getters['checkout/getFormFields'](this.formData.id, this.personNumber);
		if (typeof this.personNumber !== 'undefined') {
			Object.keys(this.form).forEach((key) => {
				this.form[key] = this.$store.getters['checkout/getFieldValue']({
					formId: this.formData.id,
					slug: key,
					personNumber: this.personNumber,
				});
			});
		}
	},
	validations() {
		const fields = this.formData.fields[this.currentStep];
		const excludeRules = [];

		if (
			this.getIsRegistrant(this.formData.id)
			&& (this.$options.name === 'CheckoutStep3' || this.$options.name === 'CheckoutStep4')
		) {
			excludeRules.push('required');
		}

		const validationData = dynamicValidateData(fields, excludeRules);

		if (this.currentStep === 5 && this.getScenario(this.formData.id) === 1) {
			return { form: {} };
		}

		return { form: validationData };
	},
	methods: {
		async addNewPerson() {
			await this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_FIELDS_DATA}`, {
				formId: this.formData.id,
				fields: { [this.getAdditionalPersonsCount(this.formData.id) + 2]: {} },
			});

			await this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
				{ formId: this.formData.id },
			);

			await this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_GET_PRICE_DATA}`,
				{ formId: this.formData.id },
			);
		},
		onBlur(field, value, isValidate, isForceBindForm) {
			this.$set(this.form, field, value);
			this.checkValidation();
			if (isForceBindForm) {
				if (Array.isArray(this.$refs.baseFields)) {
					this.$refs.baseFields.forEach((baseField) => {
						this.$set(this.form, baseField.field.slug, baseField.fieldValue);

						const children = baseField.getChildrenValues();
						if (typeof children === 'object' && children !== null) {
							Object.entries(children).forEach(([childSlug, childValue]) => {
								this.$set(this.form, childSlug, childValue);
							});
						}
					});
				}
			}
			// if (this.notFirstAttempt) {
			// this.checkValidation();
			// }
		},
		checkValidation() {
			try {
				if (!this.$v) {
					return null;
				}
				if (!this.$v.form) {
					this.$v.$touch();
				} else {
					this.$v.form.$touch();
				}

				this.isValid = true;
				this.isValidSelf = true;
				this.notFirstAttempt = true;

				if (!Object.keys(this.form).length && this.$v.$invalid) {
					this.$logger.error('Форма пустая, а правила валидации все равно срабатывают');
				}

				if (this.currentStep === 3 || this.currentStep === 4) {
					this.isValidExclusion = true;
				}

				if (Array.isArray(this.$refs.baseFields)) {
					this.$refs.baseFields.forEach((baseField) => {
						if (typeof baseField.checkValidation === 'function') {
							const fieldValidate = baseField.checkValidation(this.$v.form);
							if (fieldValidate === false) {
								this.isValid = false;
								this.isValidSelf = false;
							}
							if (!fieldValidate) {
								this.isValidExclusion = false;
							}
							if (this.isValidExclusion && fieldValidate === true) {
								this.isValid = true;
								this.isValidSelf = true;
							}
						}
					});
				}

				if (this.$refs.dropdownPayment) {
					const dropdown = this.$refs.dropdownPayment;
					const valid = dropdown.checkValidation();
					if (typeof dropdown.checkValidation === 'function' && valid === false) {
						this.isValid = false;
					}
				}

				if (Array.isArray(this.$refs.personGroups)) {
					this.$refs.personGroups.forEach((group) => {
						const valid = group.checkValidation();
						if (typeof group.checkValidation === 'function' && valid === false) {
							this.isValid = false;
						}
					});
				}

				if (
					this.currentStep === 2
					&& this.getAdditionalPersonsCount(this.formData.id) === 0
					&& this.getIsRegistrant(this.formData.id)
				) {
					this.isValid = false;
				}

				this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_VALIDATION_META}`, {
					formId: this.formData.id, step: this.currentStep, isValidate: this.isValid,
				});
				return this.isValid;
			} catch (e) {
				this.$logger.exception(e, 'checkValidation', this);
				return null;
			}
		},
	},
};
